(function () {
  var hosts = (window.Theme && window.Theme.externalLinkHosts) || [];
  hosts = hosts
    .concat([window.location.hostname])
    .filter(Boolean)
    .map(function (host) {
      return String(host).toLowerCase().replace(/^www\./, '');
    });

  function hostAllowed(hostname) {
    var normalized = String(hostname || '')
      .toLowerCase()
      .replace(/^www\./, '');
    return hosts.indexOf(normalized) !== -1;
  }

  function isShopifyHost(hostname) {
    var normalized = String(hostname || '')
      .toLowerCase()
      .replace(/^www\./, '');
    return (
      normalized === 'shopify.com' ||
      normalized.slice(-12) === '.shopify.com' ||
      normalized.slice(-14) === '.myshopify.com'
    );
  }

  // Customer account / login / register should stay same-tab (new customer accounts use shopify.com)
  function isAccountHref(href) {
    if (!href) return false;

    try {
      var url = new URL(href, window.location.origin);
      var path = (url.pathname || '').toLowerCase();
      var host = (url.hostname || '').toLowerCase().replace(/^www\./, '');

      if (
        path.indexOf('/account') !== -1 ||
        path.indexOf('/customer_authentication') !== -1 ||
        path.indexOf('/authentication') !== -1
      ) {
        return true;
      }

      if (isShopifyHost(host) && /account|login|register|authentication|customer/i.test(path + url.search)) {
        return true;
      }

      return false;
    } catch (error) {
      return false;
    }
  }

  function isExternalHref(href) {
    if (!href) return false;
    if (href.charAt(0) === '#') return false;
    if (/^(mailto|tel|sms|javascript):/i.test(href)) return false;
    if (isAccountHref(href)) return false;

    try {
      var url = new URL(href, window.location.origin);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
      return !hostAllowed(url.hostname);
    } catch (error) {
      return false;
    }
  }

  function markExternalLink(anchor) {
    if (!anchor || anchor.nodeType !== 1) return;
    if (anchor.hasAttribute('data-external-skip')) return;

    var href = anchor.getAttribute('href');

    // Account / login links must stay same-tab (even if previously marked external)
    if (isAccountHref(href)) {
      if (anchor.getAttribute('target') === '_blank') {
        anchor.removeAttribute('target');
      }
      anchor.removeAttribute('data-iera-external');
      return;
    }

    if (!isExternalHref(href)) return;

    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('data-iera-external', '1');

    var relTokens = (anchor.getAttribute('rel') || '')
      .split(/\s+/)
      .filter(Boolean);
    ['noopener', 'noreferrer'].forEach(function (token) {
      if (relTokens.indexOf(token) === -1) relTokens.push(token);
    });
    anchor.setAttribute('rel', relTokens.join(' '));
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('a[href]')) {
      markExternalLink(scope);
    }
    scope.querySelectorAll('a[href]').forEach(markExternalLink);
  }

  function init() {
    scan(document);

    if (!window.MutationObserver) return;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          scan(node);
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
